import { Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
	selector: 'pm-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css'],
})
export class AppComponent {
	pageTitle = 'San Joaquin County Office of Education';
	pageSubtitle = 'Payment Portal';
	constructor() {
		// stripe = Stripe(environment.stripeKey);
		// elements = stripe.elements();
	}
}
